import React from 'react';
import Stats from './Stats';
import { content } from '../content';
import './CTASection.css';

const CTASection: React.FC = () => {
  return (
    <Stats 
      years={content.stats.years}
      clients={content.stats.clients}
      satisfaction={content.stats.satisfaction}
    />
  );
};

export default CTASection;
